// Last 20 client events, sent with a support message so support can see what
// happened just before: screens visited, API errors, script errors and
// network changes. Paths only (no query strings), no form values.

const MAX = 20;
let ring = [];
let installed = false;

function truncate(value, max) {
  const text = value === undefined || value === null ? '' : String(value);
  return text.length > max ? text.slice(0, max) : text;
}

export function stripQuery(path) {
  return truncate(String(path || '').split(/[?#]/)[0], 200);
}

// Routes whose path carries a secret (sign-in links, password reset, unsubscribe, voucher codes).
const SECRET_ROUTES = /^\/(MagicLogin|ResetPassword|ChangePassword|Unsubscribe|GetVoucher)(\/|$)/i;
// A segment after one of these is a secret; covers the voucher API's findMasterVoucherByCode/<code>
// and createVoucherByMasterCode/<code>.
const SECRET_AFTER = /^(validation-token|unsubscribe|token|magic-link|reset-password)$|By(Master)?Code$/i;

function looksLikeToken(segment) {
  if (
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
      segment
    )
  )
    return true;
  return (
    segment.length >= 20 &&
    /^[A-Za-z0-9_\-.=%]+$/.test(segment) &&
    /\d/.test(segment) &&
    /[A-Za-z]/.test(segment)
  );
}

/** Path without query, hash or anything that looks like a token, safe to show support staff. */
export function sanitizePath(path) {
  const clean = stripQuery(path);
  const routeMatch = SECRET_ROUTES.exec(clean);
  if (routeMatch) {
    return `/${routeMatch[1]}${
      clean.length > routeMatch[0].length || routeMatch[2] ? '/:token' : ''
    }`;
  }
  const segments = clean.split('/');
  return segments
    .map((segment, index) =>
      (index > 0 && SECRET_AFTER.test(segments[index - 1])) ||
      looksLikeToken(segment)
        ? ':token'
        : segment
    )
    .join('/');
}

export function addBreadcrumb(type, name, detail) {
  const crumb = {
    type,
    name: truncate(name, 200),
    at: new Date().toISOString(),
  };
  if (detail !== undefined && detail !== null && detail !== '') {
    crumb.detail = truncate(detail, 300);
  }
  ring = ring.concat(crumb).slice(-MAX);
}

export function getBreadcrumbs() {
  return ring.slice();
}

export function clearBreadcrumbs() {
  ring = [];
}

// Window-level listeners; safe to call more than once.
export function installBreadcrumbListeners() {
  if (installed || typeof window === 'undefined') {
    return;
  }
  installed = true;
  window.addEventListener('error', event => {
    addBreadcrumb(
      'js_error',
      event && event.message ? event.message : 'Script error'
    );
  });
  window.addEventListener('unhandledrejection', event => {
    const reason = event && event.reason;
    addBreadcrumb(
      'js_error',
      (reason && reason.message) || 'Unhandled promise rejection'
    );
  });
  window.addEventListener('online', () => addBreadcrumb('network', 'online'));
  window.addEventListener('offline', () => addBreadcrumb('network', 'offline'));
}



// WEBPACK FOOTER //
// ./src/support/breadcrumbs.js